import {
  UserInfoWrapper,
  UserInfoContentWrapper,
  UserName,
  VertifyLink,
  UserInfoSection,
  UserInfoFooter,
  StyledLink,
  UserNameIcon,
  CouponTitle,
  CouponCount,
  CouponData,
  UUID,
} from "./atom";
import { Space, ToolTip, Paragraph, Tabs } from "task-eva-ui";
import ArrowIcon from "./icons/arrow";
import ClipBoardIcon from "./icons/clipboard";
import { formatCurrency } from "project-config/utils";
import { IUserInfoProps, CouponType } from "./type";
import { getTranslateNsT } from "./i18n";
import { isEn } from "project-config/utils/env";
import { useState } from "react";
import { RenderTab } from "./render-tab";
import { DesktopTab } from "./desktop-tab";

export function UserInfo({
  userInfo,
  logout,
  close,
  toAuth,
  toCoupon,
  toUserCenter,
  toRecharge,
  toPictureVip,
  onTabChange,
}: IUserInfoProps) {
  const {
    isSubAccount,
    isPictureUser,
    userName,
    uuid,
    authStatusTranslate,
    isDomestic,
    enableRemoteDesktop,
  } = userInfo;
  const t = getTranslateNsT(isEn() ? "en" : "zh");
  const [copy, setCopy] = useState(false);
  const [activeKey, setActiveKey] = useState("render");

  const renderDefaultTab = () => {
    return (
      <RenderTab
        userInfo={userInfo}
        toPictureVip={toPictureVip}
        close={close}
        toCoupon={toCoupon}
        toRecharge={toRecharge}
      />
    );
  };
  return (
    <UserInfoWrapper>
      <UserInfoContentWrapper>
        <Space direction="column" fitParent gap={14}>
          <Space gap={8}>
            <UserNameIcon>
              <span>{userName ? userName[0].toUpperCase() : ""}</span>
            </UserNameIcon>
            <Space direction="column" height="100%" gap={5}>
              <Space gap={16} align="center">
                <UserName>
                  <Paragraph
                    text={userName}
                    tooltip={!!userName && userName.length > 9}
                    maxWidth={isDomestic ? "156px" : "232px"}
                  />
                </UserName>
                {isDomestic && !isSubAccount && authStatusTranslate && (
                  <VertifyLink
                    onClick={() => {
                      toAuth?.();
                      close?.();
                    }}
                  >
                    {authStatusTranslate}
                  </VertifyLink>
                )}
              </Space>
              <Space gap={4} center>
                <UUID>{`UUID: ${uuid || ""}`}</UUID>
                <div>
                  <ToolTip
                    content={!copy ? t("copy") : t("copy_success")}
                    onBlur={() => setCopy(false)}
                  >
                    <ClipBoardIcon
                      className="clickable"
                      onClick={() => {
                        navigator.clipboard.writeText(uuid || "");
                        setCopy(true);
                      }}
                    />
                  </ToolTip>
                </div>
              </Space>
            </Space>
          </Space>
          <Tabs
            activeKey={activeKey}
            className="user-info-dropdown-tabs"
            onChange={(value) => {
              setActiveKey(value);
              onTabChange?.(value);
            }}
            items={[
              {
                key: "render",
                label: t("tab_render"),
                children: renderDefaultTab(),
              },
              {
                key: "desktop",
                label: t("tab_desktop"),
                hidden: !enableRemoteDesktop,
                children: (
                  <DesktopTab
                    userInfo={userInfo}
                    toCoupon={toCoupon}
                    close={close}
                    toRecharge={toRecharge}
                  />
                ),
              },
            ]}
          />
        </Space>
      </UserInfoContentWrapper>
      <UserInfoFooter>
        <StyledLink onClick={() => toUserCenter?.()}>
          {t("user_center")}
        </StyledLink>
        <StyledLink onClick={logout}>{t("user_signout")}</StyledLink>
      </UserInfoFooter>
    </UserInfoWrapper>
  );
}

export function CouponSection({
  onClick,
  isDomestic,
  isPictureUser,
  currencySymbol,
  couponTitle,
  couponCount,
  couponPrice,
  showCouponCount = true,
}: {
  onClick?: () => void;
  isDomestic: boolean;
  isPictureUser: boolean;
  currencySymbol: string;
  couponTitle: string;
  couponCount?: number;
  couponPrice?: number | string;
  showCouponCount?: boolean;
}) {
  const t = getTranslateNsT(isEn() ? "en" : "zh");
  return (
    <UserInfoSection onClick={onClick} isLink={!!onClick}>
      <Space fitParent center>
        <Space column gap={7}>
          <Space gap={6} center>
            <CouponTitle>
              {couponTitle}
              {!isDomestic && `(${currencySymbol})`}
            </CouponTitle>
            {showCouponCount && <CouponCount>{couponCount || 0}</CouponCount>}
          </Space>
          <CouponData>
            {isPictureUser ? (
              <>
                <span className="date">
                  {couponPrice !== "-" && t("expire_date")}
                  {couponPrice}
                </span>
              </>
            ) : (
              <>
                {isDomestic && <div className="symbol">{currencySymbol}</div>}
                <div className="currency">
                  {formatCurrency((couponPrice as number) || 0)}
                </div>
              </>
            )}
          </CouponData>
        </Space>
        <ArrowIcon />
      </Space>
    </UserInfoSection>
  );
}
